export default __webpack_public_path__ + "static/tanulo_3-e960e4db063d4671fa9890a7a82e7275.webp";